export default __webpack_public_path__ + "static/media/english.7e1f0d82.jpg";